/**
 * What the request choose screen needs to say about an entity type, read from the components
 * package where the 617 screen keeps it. Neither export is on the package index: the screen holds
 * its own copy of each type's tile words (entityTileContent.test.tsx pins them to the as-built
 * tiles), and the new-one label (CANDIDATE COPY, verifime-adr#617) is one the screen builds from
 * them.
 *
 * Deep imports from `@verifime/components/src`. Other deep imports from it are types only (admin
 * portal, views PortraitPanel); this is the first that imports a value. Kept in this one module so
 * a package index export changes one file here.
 */
import type { TEntityChoice, TSelectableEntityType } from '@verifime/components';
import { NEW_IDENTITY_CARD_COPY } from '@verifime/components/src/RequestScreens/NewIdentityCard/newIdentityCardCopy';
import { ENTITY_TILE_CONTENT } from '@verifime/components/src/RequestScreens/RequestChooseScreen/entityTileContent';
import type { ReactElement } from 'react';

/**
 * An entity choice's name, such as "Private Company": the type tile's own title. For `individual`
 * it is the Individual tile's own title, which names "just me" beside the action.
 */
export function entityTypeTitle(entityType: TEntityChoice): string {
  return ENTITY_TILE_CONTENT[entityType].title;
}

/** An entity type's description: the type tile's own words. */
export function entityTypeDescription(entityType: TSelectableEntityType): string {
  return ENTITY_TILE_CONTENT[entityType].description;
}

/** An entity type's icon, at the size the component's own stories give a row's icon. */
export function entityTypeIcon(entityType: TSelectableEntityType): ReactElement {
  const { Icon } = ENTITY_TILE_CONTENT[entityType];
  return <Icon sx={(theme) => ({ fontSize: theme.semantic.size['6xs'] })} />;
}

/** The full name shown by the action for a new one of this type, such as "A new Private Company". */
export function newIdentityName(entityType: TSelectableEntityType): string {
  return NEW_IDENTITY_CARD_COPY.cardLabel(entityTypeTitle(entityType));
}
